// src/components/NavigatorInjector.tsx
import {useEffect} from "react"
import {useNavigate} from "react-router-dom"
import {setNavigator} from "../utils/navigotor"

const NavigatorInjector = () => {
	const navigate = useNavigate()
	useEffect(() => {
		setNavigator(navigate)
	}, [navigate])
	return null
}

export default NavigatorInjector
